import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { IconEmoji } from '@atlaskit/editor-common/quick-insert';
import {
	QuickInsertMenuItem,
	type OnSelectContext,
} from '@atlaskit/editor-common/quick-insert/menu-item';

import { setInlineEmojiPopupOpen } from '../../pm-plugins/actions';

export const EmojiQuickInsertMenuItem = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const onSelect = useCallback(
		({ insert }: OnSelectContext) => setInlineEmojiPopupOpen(true)(insert('')),
		[],
	);

	return (
		<QuickInsertMenuItem
			iconBefore={<IconEmoji />}
			onSelect={onSelect}
			shortcut=":"
			title={formatMessage(messages.emoji)}
		/>
	);
};
